import {useMemo} from 'react';

import {useKeyInfoQueryContext} from '../..//MultiRunWorkspace/KeyInfoQueryContext';
import {KeyTypes} from '../common';
import {getMediaKeys} from '../utils/getMediaKeys';

export const useMediaKeys = (): {
  allMediaKeys: string[];
  defaultKeys: string[] | undefined;
  keyTypes: KeyTypes;
  numericKeys: string[];
} => {
  const {
    keyInfoQuery: {historyKeyInfo: keyInfo},
  } = useKeyInfoQueryContext();

  const mediaKeysOptions = useMemo(() => getMediaKeys(keyInfo), [keyInfo]);

  return mediaKeysOptions;
};
